import React from "react";
import { Flame, Plus, Star } from "lucide-react";
import { money } from "@/lib/api";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export default function MenuItemCard({ item, onSelect }) {
  const s = slug(item.name);
  const hasOptions = item.options?.length > 0;
  const minPrice = hasOptions ? Math.min(...item.options.map((o) => Number(o.price))) : Number(item.price);
  const isMarket = (item.tags || []).includes("Market Price");
  return (
    <div
      data-testid={`menu-item-card-${s}`}
      className="group relative rounded-2xl overflow-hidden bg-[#181D1A] border border-emerald-900/50 hover:border-amber-500/50 transition-all duration-300 flex flex-col"
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={item.image}
          alt={`${item.name} — Jamaican food by Sir. King Kitchen in Maine`}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#101311] via-transparent to-transparent" />
        <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
          {item.signature && (
            <span className="text-[10px] font-black uppercase tracking-wider px-2.5 py-1 rounded-full bg-amber-950/80 text-amber-300 border border-amber-500/50 flex items-center gap-1">
              <Star className="w-3 h-3" /> Signature
            </span>
          )}
          {item.spice && (
            <span className="text-[10px] font-black uppercase tracking-wider px-2.5 py-1 rounded-full bg-red-950/80 text-red-400 border border-red-800/60 flex items-center gap-1">
              <Flame className="w-3 h-3" /> Spicy
            </span>
          )}
        </div>
        {item.sold_out && (
          <div className="absolute inset-0 bg-black/70 grid place-items-center">
            <span className="font-display font-black uppercase tracking-widest text-red-400 text-lg rotate-[-8deg] border-2 border-red-400 px-4 py-1 rounded">Sold Out</span>
          </div>
        )}
      </div>
      <div className="p-4 flex flex-col flex-1">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-display font-bold text-lg leading-tight">{item.name}</h3>
          <span className="font-display font-black text-amber-400 text-lg whitespace-nowrap">
            {isMarket ? "Mkt" : hasOptions ? `from ${money(minPrice)}` : money(item.price)}
          </span>
        </div>
        <p className="text-sm text-[#FDFBF7]/60 mt-1.5 line-clamp-2 flex-1">{item.description}</p>
        <button
          data-testid={`menu-item-add-button-${s}`}
          disabled={item.sold_out}
          onClick={() => onSelect(item)}
          className="mt-4 inline-flex items-center justify-center gap-2 py-2.5 rounded-full bg-amber-400 hover:bg-amber-300 disabled:opacity-40 disabled:cursor-not-allowed text-[#0A2818] font-display font-black uppercase tracking-wide text-sm active:scale-95 transition-transform"
        >
          <Plus className="w-4 h-4" /> Add to Cart
        </button>
      </div>
    </div>
  );
}
